<template>
  <div :class="[$style.wrap, fullScreen && $style.fullScreen]">
    <header><span>账号注册</span></header>
    <main>
      <div :class="$style.content">
        <div :class="$style.accountWrap">
          <div :class="$style.inputWrap">
            <img :src="zhanghaoIcon" alt :class="$style.leftIcon" />
            <input type="text" placeholder="请输入用户名" v-model.trim="form.username" />
          </div>
        </div>
        <div :class="[$style.inputWrap, $style.pwd]">
          <img :src="mimaIcon" alt :class="$style.leftIcon" />
          <input type="text" placeholder="请输入密码" v-model.trim="form.password" />
        </div>
      </div>
      <div :class="$style.agree">
        <img
          :class="[agreement ? $style.xuanzhong: '']"
          @click="tocheck"
          :src="agreement ? xuanzhongIcon : weixuanzhongIcon"
          alt
        />
        <span>我已阅读并接受<span  @click="redirectArgument(0, 1)">《用户服务协议》</span>和<span @click="redirectArgument(1, 1)">《用户隐私协议》</span></span>
      </div>
      <button :class="$style.submitBtn" @click="toRegister">一键注册</button>
      <div :class="$style.redirect">
        <span @click="redirectCellLogin">手机登录</span>
        <span @click="redirectAccountLogin">账号登录</span>
      </div>
    </main>
  </div>
</template>

<script>
import { trim } from "lodash";
import { mapActions, mapMutations, mapState } from "vuex";
import { getStorage } from '@/libs/utils'
import isFullScreen from '@/libs/business/fullScreen'
import { regexpVerify } from '@/libs/business/account';

export default {
  name: "",
  data() {
    return {
      zhanghaoIcon: `${this.$cdnLink}/wanXin/orangeTheme/zhanghao.png`,
      mimaIcon: `${this.$cdnLink}/wanXin/orangeTheme/mima.png`,
      xuanzhongIcon: `${this.$cdnLink}/wanXin/orangeTheme/xuanzhong.png`,
      weixuanzhongIcon: `${this.$cdnLink}/wanXin/orangeTheme/weixuanzhong.png`,
      fullScreen: '',
      form: {},
      agreement: false, // 是否同意协议
    };
  },
  created() {
    this.fullScreen = isFullScreen();
  },
  async mounted() {
    this.getCacheAccount();
  },
  computed: {
    ...mapState({
      captchaStatus: state => state.user.captcha_status
    })
  },
  methods: {
    ...mapActions({
      getQuickAccount: "user/getQuickAccount",
    }),
    ...mapMutations({
      changeUserState: "user/CHANGE_STATE",
    }),
    async getCacheAccount() {
      const cacheAccount = getStorage("quick_register_account");
      if (!cacheAccount) {
        await this.getQuickAccount();
        const { username, password } = this.$store.state.user;
        this.form = {
          username,
          password,
        };
      } else {
        this.form = cacheAccount;
      }
    },
    tocheck() {
      this.agreement = !this.agreement;
    },
    async toRegister() {
      await regexpVerify(this.form, [        
        { key: 'username', hint: '账号由6-36位数字或字母组成', type: 'username' },
        { key: 'password', hint: '密码由6-18位数字或字母组成', type: 'password' },
      ]);
      await this.changeUserState(this.form);
      this.$emit("register", {
        agreementState: this.agreement
      });
    },
    redirectAccountLogin() {
      this.$emit("redirectAccountLogin");
    },
    redirectCellLogin() {
      this.$emit("redirectCellLogin");
    },
    redirectArgument(type, source) {
      this.$emit("redirectArgument", type, source);
    },
  },
};
</script>

<style lang="scss" module>
@import "../../../assets/css/common.scss";

.wrap {
  @include common-window(true);
  > main {
    padding-top: 0.35rem;
    .accountWrap {
      position: relative;
    }
    .inputWrap {
      @include common-inputWrap();
      justify-content: flex-start;
      padding-left: 0.25rem;
      .leftIcon {
        margin-right: 0.16rem;
      }
      &.pwd {
        margin-top: 0.33rem;
      }
    }
    .redirect {
      display: flex;
      color: $primary-color-1;
      justify-content: space-between;
      width: 4.44rem;
      margin: auto;
      font-size: $font-nm-1;
      > span {
        padding: 0.30rem 0.22rem 0.22rem 0.29rem;
        &:active {
          opacity: 0.8;
        }
      }
    }
    .submitBtn {
      @include common-button();
      margin-top: .14rem;
    }
    .agree {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 0.2rem;
      color: #999999;
      margin-top: 0.16rem;
      > img {
        width: 0.17rem;
        height: 0.17rem;
        margin-right: 0.1rem;
        margin-top: 0.02rem;
      }
    }
  }
  &.fullScreen {
    @include full-screen-window(true);
    > main {
      padding-top: 17px;
      .accountWrap {
        position: relative;
      }
      .inputWrap {
        @include full-screen-inputWrap();
        justify-content: flex-start;
        padding-left: 12px;
        .leftIcon {
          margin-right: 8px;
        }
        &.pwd {
          margin-top: 16px;
        }
      }
      .redirect {
        display: flex;
        color: $primary-color-1;
        justify-content: space-between;
        width: 222px;
        margin: auto;
        font-size: $font-nm;
        > span {
          padding: 15px 11px 11px 14px;
          &:active {
            opacity: 0.8;
          }
        }
      }
      .submitBtn {
        @include full-screen-button();
        margin-top: 7px;
      }
      .agree {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 10px;
        color: #999999;
        margin-top: 8px;
        > img {
          width: 8px;
          height: 8px;
          margin-right: 5px;
          margin-top: 1px;
        }
      }
    }
  }
}
</style>